
import React from 'react';
import { motion } from 'framer-motion';
import { Hospital, ShieldCheck, UserCheck, Briefcase } from 'lucide-react';
import { Card } from '@/components/ui/card';

const WhoWeHelpSection = () => {
  const personas = [
    {
      title: "ACOs",
      icon: <Hospital className="h-8 w-8 text-morgenBlue" />,
      description: "Enhance quality measures and reduce costs through targeted clinical interventions that drive meaningful outcomes."
    },
    {
      title: "Medicare Advantage Plans",
      icon: <ShieldCheck className="h-8 w-8 text-morgenViolet" />,
      description: "Boost Star ratings and optimize HCC capture through AI-driven engagement that activates timely care."
    },
    {
      title: "VBC Enablers",
      icon: <UserCheck className="h-8 w-8 text-morgenTeal" />,
      description: "Embed Morgen into your platform to power measurable care activation and drive clinical ROI at scale."
    },
    {
      title: "Self-Insured Employers",
      icon: <Briefcase className="h-8 w-8 text-morgenPurple" />,
      description: "Reduce healthcare costs while delivering personalized care pathways that improve employee outcomes."
    }
  ];

  return (
    <section id="who-we-help" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Who We Help</h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            Morgen partners with organizations committed to value-based care to drive better outcomes 
            and transform financial performance.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {personas.map((persona, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full bg-white border-none rounded-xl p-8 shadow-md hover:shadow-lg transition-all duration-300 relative overflow-hidden group">
                {/* Subtle branded gradient overlay */}
                <div className="absolute top-0 left-0 w-full h-1 bg-morgen-gradient"></div>
                
                <div className="flex flex-col h-full">
                  <div className="mb-4 p-3 rounded-full bg-gray-50 w-fit group-hover:bg-gray-100 transition-colors">
                    {persona.icon}
                  </div>
                  
                  <h3 className="text-2xl font-bold mb-3 text-morgenDarkCharcoal">{persona.title}</h3>
                  <p className="text-gray-600 text-lg">{persona.description}</p>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelpSection;
